module.exports = __webpack_public_path__ + "static/media/button_staking.601dd22d.png";